const routes = [
    { 
      path: 'upload/', 
      name: 'QuotationUpload',
      meta: { title: 'Upload to Quotations', showQuotationsModal: true, modalType: 'upload' } ,
      children: [
        { path: 'quotation/add', name: 'QuotationUploadQuotation',
          meta: { 
            title: 'Upload Quotation',
            showQuotationsModal: true,
            modalType: 'upload',
            uploadType: 'quotation' 
          } 
        },
        { path: 'correction/add', name: 'QuotationUploadCorrection',
          meta: { 
            title: 'Upload Correction',
            showQuotationsModal: true,
            modalType: 'upload',
            uploadType: 'correction'
          } 
        },
      ] 
    },
  ] 
  
  export default routes;
  